module.exports = __webpack_public_path__ + "img/weddings_36_V.261c3606.webp";